import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "creating-rest-apis"
    }}>{`Creating REST APIs`}</h1>
    <p>{`You can create REST APIs from web actions you`}{`’`}{`ve deployed to Adobe I/O Runtime. Let`}{`’`}{`s assume that you`}{`’`}{`ve created four actions to manage CRUD operations for the `}<inlineCode parentName="p">{`pet`}</inlineCode>{` entity:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`CRUD Operation`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Action Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Create`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`addPet`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Read`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`getPet`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Update`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`updatePet`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Delete`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`deletePet`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`You can map these actions to a REST API for managing `}<inlineCode parentName="p">{`pet`}</inlineCode>{` resources:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Endpoint`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`HTTP Method`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Action Nam`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`/pet`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`POST`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`addPet`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`/pet`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GET`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`getPet`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`/pet/{id}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GET`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`getPet`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`/pet/{id}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`PUT`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`updatePet`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`/pet/{id}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`DELETE`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`deletePet`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`Let`}{`’`}{`s see how you can create this API, assuming you have the web actions are already deployed/created.`}</p>
    <h1 {...{
      "id": "how-long-does-it-take-to-createupdate-an-api"
    }}>{`How long does it take to create/update an API`}</h1>
    <p>{`When creating or updating a REST API, it can take up to 5 minutes to see the changes. `}</p>
    <h2 {...{
      "id": "using-wsk-cli"
    }}>{`Using wsk CLI`}</h2>
    <p>{`Using the `}<inlineCode parentName="p">{`aio rt:api:create`}</inlineCode>{` command, you create each API endpoint one-by-one. This command allows you to set a base path, path, method, and response type. We will set:`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:api:create /pet-store /pet post createPet --response-type http
aio rt:api:create /pet-store /pet get getPet --response-type http
aio rt:api:create /pet-store /pet/{id} get getPet --response-type http
aio rt:api:create /pet-store /pet/{id} put updatePet --response-type http
aio rt:api:create /pet-store /pet/{id} delete deletePet --response-type http
`}</code></pre>
    <p>{`You can quickly see the API you`}{`’`}{`ve defined, including the fully qualified path, by running this command:`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:api:list /pet-store
`}</code></pre>
    <p>{`Please note, that at this time `}<inlineCode parentName="p">{`aio rt:api:list`}</inlineCode>{` is not implemented. Instead, you have to use `}<inlineCode parentName="p">{`aio rt:api:list/enter-base-path`}</inlineCode>{`.`}</p>
    <p>{`Here is an example of calling one of the endpoints:`}</p>
    <pre><code parentName="pre" {...{}}>{`curl https://adobeioruntime.net:443/apis/<YOUR-NAMESPACE>/pet-store/pet/2345 -X get
`}</code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{}}>{`curl https://<YOUR-NAMESPACE>.adobeioruntime.net:443/apis/pet-store/pet/2345 -X GET
`}</code></pre>
    <p><strong parentName="p">{`Note`}</strong>{` the change in the URL here in comparison to what the `}<inlineCode parentName="p">{`aio`}</inlineCode>{` returns. This is due some additional protections Runtime provides to segregate namespaces from each other when invoking web actions. The `}<inlineCode parentName="p">{`aio`}</inlineCode>{` generated link will still work but it will return a 308 redirect to your namespace's subdomain on Runtime. For a further discussion of this please see the `}<a parentName="p" {...{
        "href": "securing_web_actions.md"
      }}>{`Securing Web Actions`}</a>{` page.`}</p>
    <p>{`In the example above, the `}<inlineCode parentName="p">{`{di}`}</inlineCode>{` value, 2335, will be mapped to a {payload.id}.`}</p>
    <h2 {...{
      "id": "using-swagger-files"
    }}>{`Using Swagger files`}</h2>
    <p>{`A neat feature when working with REST APIs is the support for Swagger files. This works for creating a new REST API from scratch or, if you already used the `}<inlineCode parentName="p">{`aio`}</inlineCode>{` CLI to create one,  saving the API as a Swagger definition file that you can use later on to restore the API.`}</p>
    <p>{`Continuing the example above, if you run this command, you`}{`’`}{`ll create a Swagger definition file on your machine out of the pet-store API:`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:api:get /pet-store > pet-store-swagger.json
`}</code></pre>
    <p>{`Suppose that you want to restore or create the same API, maybe in some other namespace. All you have to is to run:`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:api:create --config-file pet-store-swagger.json
`}</code></pre>
    <p>{`This will work as long as the actions are already created in that namespace.`}</p>
    <h2 {...{
      "id": "enable-cors-on-an-http-resource"
    }}>{`Enable CORS on an HTTP Resource`}</h2>
    <p><a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS"
      }}>{`CORS`}</a>{` headers can be controlled in two ways: statically, or dynamically.`}</p>
    <h3 {...{
      "id": "static-cors-response-with-openapi"
    }}>{`Static CORS Response with OpenAPI`}</h3>
    <p>{`If the returned CORS headers can be static, no code is necessary. The REST APIs can be configured in OpenAPI 2.0 format, by defining the `}<inlineCode parentName="p">{`options`}</inlineCode>{` method. The following snippet illustrates how to configure CORS headers:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"paths": {
    "/test": {
      "options": {
        "responses": {
          "204": {
            "description": "Default CORS response",
            "headers": {
              "Access-Control-Allow-Origin": {
                "type": "string",
                "description": "Which origin can invoke the /test API\\n",
                "default": "https://xyz.example.com"
              },
              "Access-Control-Allow-Methods": {
                "type": "string",
                "description": "Which methods are allowed\\n",
                "default": "GET, POST, PUT"
              }
            }
          }
        }
      }
    }
}
`}</code></pre>
    <p>{`Once the `}<inlineCode parentName="p">{`options`}</inlineCode>{` block is added to any HTTP resource, the system will respond with the configured headers, and their corresponding `}<inlineCode parentName="p">{`default`}</inlineCode>{` values. In this example the response will be:`}</p>
    <pre><code parentName="pre" {...{}}>{` HTTP/1.1 204 No Content
 Access-Control-Allow-Methods: GET, POST, PUT
 Access-Control-Allow-Origin: https://xyz.example.com

`}</code></pre>
    <h4 {...{
      "id": "dynamic-cors-response-with-custom-actions"
    }}>{`Dynamic CORS Response with Custom Actions`}</h4>
    <p>{`The CORS headers can also be returned by a dedicated function, which must be configured to handle the `}<inlineCode parentName="p">{`options`}</inlineCode>{` HTTP Method. It works in the same fashion as the other HTTP Methods like `}<inlineCode parentName="p">{`GET`}</inlineCode>{`, or `}<inlineCode parentName="p">{`POST`}</inlineCode>{`.`}</p>
    <p>{`The code bellow demonstrates an action that returns a CORS response:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// save it as cors-action.js
function main(params) {
  return {
    statusCode: 204,
    headers: {
      "Access-Control-Allow-Origin": "https://xyz.example.com",
      "Access-Control-Allow-Methods": "GET, POST, PUT"
    }
  }
}
`}</code></pre>
    <p>{`The web action must be created and configured for the CORS request:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`aio rt:action:create handleCorsRequest ./cors-action.js --web true -a web-custom-options true

aio rt:api:create /pet-store /pet options handleCorsRequest --response-type http
`}</code></pre>
    <p>{`To test the CORS request get the URL of the action, and invoke it:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`aio rt:api:list /pet-store
# get the URL for the options action and invoke it
curl -i -X OPTIONS https://adobeioruntime.net/...
# it should return
 HTTP/1.1 204 No Content
 Access-Control-Allow-Methods: GET, POST, PUT
 Access-Control-Allow-Origin: https://xyz.example.com
`}</code></pre>
    <h2 {...{
      "id": "securing-the-api-endpoints"
    }}>{`Securing the API endpoints`}</h2>
    <h3 {...{
      "id": "oauth-using-the-adobe-identity-management-system"
    }}>{`Oauth (using the Adobe Identity Management System)`}</h3>
    <p>{`An action can be configured to require IMS validation for incoming requests using the following command: `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`aio rt:action:create <action_name> --web true -a require-gw-validation true
`}</code></pre>
    <h4 {...{
      "id": "scopes-validation"
    }}>{`Scopes validation`}</h4>
    <p>{`Once IMS authentication has been enabled for an action, the only way to allow access to the action is by specifying a list of IMS scopes or client IDs that are permitted to invoke the action. `}</p>
    <p>{`The following code snippet demonstrates how to configure access using a standard Swagger file and the `}<inlineCode parentName="p">{`security`}</inlineCode>{` object:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "basePath": "/v2",
    "paths": {
      "/ims-secure-endpoint": {
        "get": {
          "operationId": "your-namespaces/default/my-ims-secure-web-action.json",        
          "security": [
            {
              "scopes_auth": [
                  "write:pets",
                  "read:pets"
                ]
            }
          ]
        }
      }
    },
    "securityDefinitions": {
        "scopes_auth": {
          "type": "oauth2",
          "authorizationUrl": "",
          "flow": "implicit",
          "scopes": {
            "write:pets": "modify pets in your account",
            "read:pets": "read your pets"
          }
        }
    }
}
`}</code></pre>
    <p>{`This enables scope validation for the API endpoint, allowing requests with access tokens that have the scopes `}<inlineCode parentName="p">{`write:pets`}</inlineCode>{` OR `}<inlineCode parentName="p">{`read:pets`}</inlineCode>{`. Requests that do not have the required scopes in the access token will be rejected with the following error message: `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "error_code":"401015",
  "message":"Scope mismatch"
}
`}</code></pre>
    <p>{`After publishing the Swagger file, this endpoint `}<inlineCode parentName="p">{`your-namespaces/default/my-require-gw-validation-web-action`}</inlineCode>{` can be used to call the action: `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -i -H "Authorization: Bearer <ims_access_token>" https://guest.adobeioruntime.net/api/v2/ims-validation-endpoint
`}</code></pre>
    <h4 {...{
      "id": "client-id-validation"
    }}>{`Client ID validation`}</h4>
    <p><inlineCode parentName="p">{`client_id`}</inlineCode>{` validation can be enabled by adding `}<inlineCode parentName="p">{`x-client-ids`}</inlineCode>{` with a list of clients that are allowed to invoke the action. The clientId list has to be added to the `}<inlineCode parentName="p">{`security definition`}</inlineCode>{` object in the Swagger. Also make sure to add the security definition key to the method `}<inlineCode parentName="p">{`security`}</inlineCode>{` object, otherwise the validation won't be enabled for that method: `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "basePath": "/v2",
    "paths": {
      "/ims-validation-endpoint": {
        "get": {
          "operationId": "your-namespaces/default/my-require-gw-validation-web-action.json",
          "security": [
            {
              "clientids_auth": []
            }
          ]
        }
      }
    },
    "securityDefinitions": {
        "clientids_auth": {
          "type": "oauth2",
          "authorizationUrl": "",
          "flow": "implicit",
          "scopes": {
            "write:pets": "modify pets in your account",
            "read:pets": "read your pets"
          },
          "x-client-ids": ["zookeeper", "dogwalker"]
        }
    }
}
`}</code></pre>
    <p>{`This configuration allows the action to accept requests with access tokens that have the client IDs `}<inlineCode parentName="p">{`zookeeper`}</inlineCode>{` OR `}<inlineCode parentName="p">{`dogwalker`}</inlineCode>{`. Requests that do not have the client ID in the access token will be rejected with the following error message: `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "error_code":"403201",
  "message":"Client ID not allowed to call this service"
}
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Note that both `}<inlineCode parentName="p">{`scope`}</inlineCode>{` and `}<inlineCode parentName="p">{`client_id`}</inlineCode>{` validation can be enabled at the same time. In this case, the request will be rejected if the access token does not have the required scope AND client ID.`}</p>
      <p parentName="blockquote">{`In case no validation is enabled for the endpoint's verb, by removing the `}<inlineCode parentName="p">{`security`}</inlineCode>{` object from the method definition, the action can be invoked publicly without any restrictions on the API url.`}</p>
      <p parentName="blockquote">{`By default, the IMS token validation URL will be used for token validation so "authorizationUrl" can be left empty. However, if you want to use a different Oauth provider, you can specify the `}<inlineCode parentName="p">{`authorizationUrl`}</inlineCode>{` in the `}<inlineCode parentName="p">{`securityDefinition`}</inlineCode>{` object. Only one external security provider can be configured, and it needs to be defined in the first `}<inlineCode parentName="p">{`securityDefinition`}</inlineCode>{` object in the Swagger file.`}</p>
      <p parentName="blockquote">{`Please allow a 5minute window for the changes to take effect.`}</p>
    </blockquote>
    <h3 {...{
      "id": "basic-authentication"
    }}>{`Basic Authentication`}</h3>
    <p>{`You secure an API the same way you`}{`’`}{`d do it for web actions. You can read more about this on the `}<a parentName="p" {...{
        "href": "securing_web_actions.md"
      }}>{`Securing Web Actions`}</a>{` page.`}</p>
    <p>{`Once you`}{`’`}{`ve enabled basic authentication for an action, you`}{`’`}{`d have to pass the `}<inlineCode parentName="p">{`X-Require-Whisk-Auth`}</inlineCode>{` header and the secret you chose when making an API call.`}</p>
    <h3 {...{
      "id": "ip-allow-list--disallow-list"
    }}>{`IP Allow-list / Disallow-list`}</h3>
    <p>{`Endpoints can also be configured to only allow/block requests from specific IP addresses. This can be done by adding the `}<inlineCode parentName="p">{`x-ip-allowlist`}</inlineCode>{` or `}<inlineCode parentName="p">{`x-ip-disallowlist`}</inlineCode>{` to the method definition as follows:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "basePath": "/v2",
    "paths": {
      "/ip-validation-endpoint": {
        "get": {
          "operationId": "your-namespaces/default/my-require-gw-validation-web-action.json",
          "x-ip-allowlist": ["192.150.10.210", "192.168.0.1"],
          "x-ip-disallowlist": ["192.150.10.10"]
        }
      }
    }
}
`}</code></pre>
    <p>{`This configuration allows the action to accept requests from clients with the IP addresses "192.150.10.210" or "192.168.0.1", and block requests from "192.150.10.10". `}</p>
    <p>{`Requests that do not have the requests originating from the IP addresses in the whitelist will be rejected with the following error message:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "error_code":"403013",
  "message":"Access from your IP address is not authorized"
}
`}</code></pre>
    <p>{`Requests that have the requests originating from the IP addresses in the disallow list, will be rejected with the following error message:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "error_code":"403012",
  "message":"Access from your IP address is not authorized"
}
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Make sure that the `}<inlineCode parentName="p">{`my-require-gw-validation-web-action`}</inlineCode>{` is configured to be a web action with `}<inlineCode parentName="p">{`-a require-gw-validation true`}</inlineCode>{`, otherwise the action can be accessed publicly without any restrictions on the non api url. `}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      